import { useMemo } from 'react';
import type { ODataGridColumn } from '@inuxe/prime-odata-grid';
import type { IPerson } from '../../../models/person/PersonModel';
import PersonsActionCell from './parts/PersonsActionCell';

export function usePersonsColumns(): ODataGridColumn<IPerson>[] {
  return useMemo<ODataGridColumn<IPerson>[]>(
    () => [
      {
        id: 'actions',
        header: 'İşlemler',
        sortable: false,
        filter: false,
        width: 120,
        className: 'grid-action-column',
        actionSticky: 'left',
        body: row => <PersonsActionCell row={row} />,
      },
      {
        field: 'name',
        header: 'İsim',
        minWidth: 150,
        sortable: true,
        filter: true,
      },
      {
        field: 'hospitalName',
        header: 'Hastane',
        minWidth: 150,
        sortable: true,
        filter: true,
      },
      {
        field: 'phoneNumber',
        header: 'Telefon Numarası',
        minWidth: 150,
        sortable: true,
        filter: true,
      },
      {
        field: 'email',
        header: 'E-mail',
        minWidth: 200,
        sortable: true,
        filter: true,
      },
    ],
    []
  );
}
